<template>
  <v-layout justify-end>
    <v-btn outline slot="activator" color="primary" class="mb-2" @click="open">
      <v-icon dark left>note_add</v-icon>New Item
    </v-btn>
    <v-dialog v-model="localDialog" persistent max-width="1500px" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container fluid>
            <v-form ref="form">
              <v-layout row wrap>

<!--                first col-->
                <v-flex>
                  <!--                image part-->
                  <image-uploader
                    v-bind:constImage="local.image"
                    v-bind:dialog="dialog"
                    v-bind:errorMsg="errorMsg"
                    @image="assignImage"/>
                  <!--                name part-->
                  <v-text-field
                    label="Name"
                    v-model="local.name"
                    :rules="generalRules"
                    required>
                  </v-text-field>
                  <!--                 Service Part-->
                  <v-text-field
                    v-model="local.service"
                    label="Service (Optional)">
                  </v-text-field>
                  <!--                Description part-->
                  <v-textarea
                    label="Description (Optional)"
                    v-model="local.description">
                  </v-textarea>
                </v-flex>
                <v-spacer></v-spacer>
                <v-divider vertical></v-divider>
                <v-spacer></v-spacer>
<!--                Second col-->
                <v-flex>
                  <!--                Allowed Sounds part-->
                  <h3>Sound</h3>
                  <v-select
                    :items="sounds"
                    :item-text="item => item.name"
                    :item-value="item=> item.id"
                    v-model="local.allowed_sounds"
                    label="Allowed Sounds"
                    multiple
                    chips
                    persistent-hint>
                  </v-select>
                  <!--                select Rigs-->
                  <h3>Rig</h3>
                  <v-select
                    :items="type_of_rig"
                    :item-text="item => item.name"
                    :item-value="item=> item.name"
                    v-model="local.rig"
                    label="Type of Rig"
                    persistent-hint>
                  </v-select>
                  <!--                select Animations-->
                  <h3>Animations</h3>
                  <v-select
                    :items="animations"
                    :item-text="item => item.name"
                    :item-value="item=> item.id"
                    v-model="local.allowed_animations"
                    label="Allowed Animations"
                    multiple
                    chips
                    persistent-hint>
                  </v-select>
                  <popover :always="true">
                    <h3>Select Materials</h3>
                  </popover>
                  <v-select
                    :items="materialsSelect"
                    v-model="local.materials"
                    label="Select Materials">
                  </v-select>
                  <popover :always="true">
                    <h3>Interactive Surfaces</h3>
                  </popover>
                  <v-select
                    :items="interactiveSurfacesSelect"
                    v-model="local.interactive_surfaces"
                    label="Select Interactive Surfaces">
                  </v-select>
<!--                                  Interactive Surface(Not finished)-->

<!--                  <H3 align="left">Interactive Surface()</H3>-->
<!--                  <v-text-field v-model="local.surface" label="Interactive Surface" >-->
<!--                  </v-text-field>-->
<!--                  <p align="right">{{local.surface.length}} interactive surface founded</p>-->
                </v-flex>
                <v-spacer />
<!--                Third col-->
                <v-flex>
                  <!--                Polygon Count-->
                  <v-text-field
                    v-model="local.polygonLimitation"
                    label="Polygon Limitation">
                  </v-text-field>
                  <v-text-field
                    v-model="local.polygon_count"
                    label="Polygon Count"
                    type="number">
                  </v-text-field>
                  <!--                X, Y, Z-->
                  <H3 >Dimension in meters</H3>
                  <v-layout>

                    <v-text-field
                      v-model="local.dimension.X"
                      label="Dimension X"
                      type="number">
                    </v-text-field>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="local.dimension.Y"
                      label="Dimension Y"
                      type="number">
                    </v-text-field>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="local.dimension.Z"
                      label="Dimension Z"
                      type="number">
                    </v-text-field>
                  </v-layout>
                  <H3 >Position of Origin</H3>
                  <v-layout>

                    <v-text-field
                      v-model="local.positionOfOrigin.X"
                      label="Dimension X"
                      type="number">
                    </v-text-field>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="local.positionOfOrigin.Y"
                      label="Dimension Y"
                      type="number">
                    </v-text-field>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="local.positionOfOrigin.Z"
                      label="Dimension Z"
                      type="number">
                    </v-text-field>
                  </v-layout>
                  <h3 >Rotation of Origin</h3>
                  <v-layout>
                    <v-text-field
                      v-model="local.rotationOfOrigin.X"
                      label="Dimension X"
                      type="number">
                    </v-text-field>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="local.rotationOfOrigin.Y"
                      label="Dimension Y"
                      type="number">
                    </v-text-field>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="local.rotationOfOrigin.Z"
                      label="Dimension Z"
                      type="number">
                    </v-text-field>
                  </v-layout>
                  <h3 >Scale</h3>
                  <v-layout>
                    <v-text-field
                      v-model="local.scale"
                      label="Model scale"
                      type="number"
                      min='0'>
                    </v-text-field>
                  </v-layout>
                </v-flex>
               
                <v-spacer />
<!--                Forth col-->
                <v-flex>
                  <div >
                  <h3>Attachments</h3>
<!--                  upload fbx-->
                  <!-- :rules="generalRules" used here in all 4 inputs -->
                  <file-uploader
                    @input="assignFBX"
                    v-model="local.fbx">
                    <div slot="activator" >
                      <v-text-field
                        label="3D Model"
                        v-model="local.fbx.fileName"
                        readonly prepend-icon="attach_file"
                        
                      >
                      </v-text-field>
                    </div>
                  </file-uploader>
<!--                  upload ios bundle-->
                  <file-uploader v-if="local.asset_bundle"
                    @input="assignIOS"
                    v-model="local.asset_bundle.iOS">
                    <div slot="activator">
                      <v-text-field
                        v-if="local.asset_bundle.iOS"
                        label="iOS Asset Bundle"
                        v-model="local.asset_bundle.iOS.fileName"
                        readonly prepend-icon="attach_file"
                        >
                      </v-text-field>
                    </div>
                  </file-uploader>
<!--                  upload android bundle-->
                  <file-uploader
                    @input="assignAndroid" v-if="local.asset_bundle"
                    v-model="local.asset_bundle.Android">
                    <div slot="activator">
                      <v-text-field
                        v-if="local.asset_bundle.Android"
                        label="Android Asset Bundle"
                        v-model="local.asset_bundle.Android.fileName"
                        readonly prepend-icon="attach_file"
                        >
                      </v-text-field>
                    </div>
                  </file-uploader>
                  <file-uploader
                    @input="assignWebGL"
                    v-model="local.asset_bundle.WebGL">
                    <div slot="activator">
                      <v-text-field
                        label="WebGL Asset Bundle"
                        v-model="local.asset_bundle.WebGL.fileName"
                        readonly prepend-icon="attach_file"
                        >
                      </v-text-field>
                    </div>
                  </file-uploader>
                </div>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer/>

<!--          Cancel Button -->
          <v-btn color="primary" outline @click="close">Cancel</v-btn>

<!--          Save Button-->
          <v-btn v-if="showSaveButton" color="primary" @click="save">
            <v-flex v-if="this.saving">
              <v-progress-circular
                indeterminate
                color="primary">
              </v-progress-circular>
            </v-flex>
            <v-flex v-else>Save</v-flex>
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import {db} from '../../../firebaseDB'
import ImageUploader from '../uploader/imageUploader'
import VUpload from 'vuetify-upload-component'
import FileUploader from '../uploader/fileUploader'

export default {
  name: 'addProps',
  components: {ImageUploader, VUpload, FileUploader},
  data: () => ({
    // numOfSurface: 0, // how many surface the model has
    valid: true,
    errorMsg: '',
    generalRules: [
      v => !!v || 'This field is required'
    ],
    allow_animation: false,
    is_rigged: false,
    animations: [],
    sounds: [],
    type_of_rig: [
      {
        name: 'Humanoid'
      },
      {
        name: 'Custom'
      }
    ],
    materialsSelect: [],
    interactiveSurfacesSelect: [],
    saving: false,
    // all props need to be save
    local: {
      id: null,
      name: '',
      service: '',
      description: '',
      image: null,
      allowed_sounds: [],
      allowed_animations: [],
      rig: '',
      surface: [1],
      polygon_count: 1,
      dimension: {
        X: 0,
        Y: 0,
        Z: 0
      },
      rotationOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      positionOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      fbx: {
        fileName: '',
        file: '',
        fileURL: ''
      },
      asset_bundle: {
        iOS: {
          fileName: '',
          file: '',
          fileURL: ''
        },
        Android: {
          fileName: '',
          file: '',
          fileURL: ''
        },
        WebGL: {
          fileName: '',
          file: '',
          fileURL: ''
        }
      },
      scale: 0,
      materials: '',
      interactive_surfaces: '',
      polygonLimitation: ''
    }
  }),
  props: {
    dialog: '',
    editedID: '',
    showSaveButton: true,
    info: {
      id: null,
      name: '',
      description: '',
      image: null,
      allowed_sounds: [],
      allowed_animations: [],
      fileURL: '',
      type_of_rig: '',
      fbx: {
        fileName: '',
        file: '',
        fileURL: ''
      },
      asset_bundle: {
        iOS: {
          fileName: '',
          file: '',
          fileURL: ''
        },
        Android: {
          fileName: '',
          file: '',
          fileURL: ''
        },
        WebGL: {
          fileName: '',
          file: '',
          fileURL: ''
        }
      },
      scale: 0,
    }
  },
  created () {
    db.ref('assets/asset_data/prop_action')
      .once('value')
      .then(snapshot => {
        Object.keys(snapshot.val())
          .forEach(k => this.animations.push({
            id: k,
            name: snapshot.val()[k].name || k
          }))
      })
      .catch(error => {
        console.log('Error - ' + error.message)
      })
    db.ref('assets/asset_data/sound')
      .once('value')
      .then(snapshot => {
        Object.keys(snapshot.val())
          .forEach(k => this.sounds.push({
            id: k,
            name: snapshot.val()[k].name || k
          }))
      })
      .catch(error => {
        console.log('Error - ' + error.message)
      })
  },
  computed: {
    // checkTitle () {
    //   // this.stories = this.stories.filter(story => story.owner === this.user)
    //   if (this.local.title.length < 1 && this.local.title !== '') {
    //     return 'Story title has to be at least 1 characters'
    //   } else {
    //     return true
    //   }
    // },
    localDialog: {
      get: function () {
        return this.dialog
      }
    },
    formTitle () {
      return this.editedID === -1 ? 'New 3D Model' : this.showSaveButton ? 'Edit 3D Model' : 'Preview 3D Model'
    }
  },
  watch: {
    info (val) {
      this.local = Object.assign({}, val)
    },
    dialog (val) {
      if (!val) {
        this.saving = false
      }
    },
    allow_animation (value) {
      if (value === false) {
        this.local.allowed_animations = []
      }
    },
    is_rigged (value) {
      if (value === false) {
        this.local.rig = ''
      }
    }
  },
  methods: {
    assignImage (val) {
      this.local.image = val
    },
    open () {
      this.$emit('open')
    },
    close () {
      this.$emit('close')
      // this.$router.go(0)
    },
    validateForm () {
      let flag = this.$refs.form.validate()
      if (this.local.image === null) {
        flag = false
        this.errorMsg = 'Please add a picture'
      }
      console.log(flag)
      return flag
    },
    save () {
      if (this.validateForm()) {
        this.saving = true
        this.$emit('save', this.local)
      }
    },
    assignFBX (payload) {
      this.local.fbx = payload
    },
    assignIOS (payload) {
      this.local.asset_bundle.iOS = payload
    },
    assignAndroid (payload) {
      this.local.asset_bundle.Android = payload
    },
    assignWebGL (payload) {
      this.local.asset_bundle.WebGL = payload
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/assets/add-new/addModel2D.vue